<template>
    <!-- Modal gallery -->
<section class="">

<b-card>
  <b-table :items="items" :fields="fields">
      <template v-slot:cell(quantidade)="data">
        <b-form-input
          type="number"
          v-model="data.item.quantidade"
          @input="updateTotal(data.index)"
        ></b-form-input>
      </template>

      <template v-slot:cell(valorUnitario)="data">
        <b-form-input
          type="number"
          v-model="data.item.valorUnitario"
          @input="updateTotal(data.index)"
        ></b-form-input>
      </template>

      <template v-slot:cell(valorTotal)="data">
        {{ data.item.valorTotal.toFixed(2) }}
      </template>
    </b-table>
</b-card>


<b-card>


  <div class="container">
<div class="row d-flex flex-wrap align-items-center" data-toggle="modal" data-target="#lightbox">
  <div class="col-12 col-md-6 col-lg-3">
    
<img src="https://source.unsplash.com/random/200" data-target="#indicators" data-slide-to="0" alt="" /> 
  </div>
  <div class="col-12 col-md-6 col-lg-3">
       <img src="https://source.unsplash.com/random/201" data-target="#indicators" data-slide-to="1" alt="" />
  </div>
  <div class="col-12 col-md-6 col-lg-3">
     <img src="https://source.unsplash.com/random/202" data-target="#indicators" data-slide-to="2"  alt="" />
  </div>
  <div class="col-12 col-md-6 col-lg-3">
       <img src="https://source.unsplash.com/random/203" data-target="#indicators" data-slide-to="3" alt="" />
  </div>
  <div class="col-12 col-md-6 col-lg-3">
       <img src="https://source.unsplash.com/random/204" data-target="#indicators" data-slide-to="3"  alt="" />
  </div>
  <div class="col-12 col-md-6 col-lg-3">
       <img src="https://source.unsplash.com/random/205" data-target="#indicators" data-slide-to="4" alt="" />
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="lightbox" role="dialog" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
        <button type="button" class="close text-right p-2" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      <div id="indicators" class="carousel slide" data-interval="false">
  <ol class="carousel-indicators">
    <li data-target="#indicators" data-slide-to="0" class="active"></li>
    <li data-target="#indicators" data-slide-to="1"></li>
    <li data-target="#indicators" data-slide-to="2"></li>
    <li data-target="#indicators" data-slide-to="3"></li>
    <li data-target="#indicators" data-slide-to="4"></li>
    <li data-target="#indicators" data-slide-to="5"></li>
  </ol>
  <div class="carousel-inner">
    
    <div class="carousel-item active">
      
      <img class="d-block w-100" src="https://source.unsplash.com/random/200" alt="First slide">
    </div>
    <div class="carousel-item">
      <img class="d-block w-100" src="https://source.unsplash.com/random/201" alt="Second slide">
    </div>
    <div class="carousel-item">
      <img class="d-block w-100" src="https://source.unsplash.com/random/202" alt="Third slide">
    </div>
    <div class="carousel-item">
      <img class="d-block w-100" src="https://source.unsplash.com/random/203" alt="Fourth slide">
    </div>
    <div class="carousel-item">
      <img class="d-block w-100" src="https://source.unsplash.com/random/204" alt="Fifth slide">
    </div>
    <div class="carousel-item">
      <img class="d-block w-100" src="https://source.unsplash.com/random/205" alt="Sixth slide">
    </div>
  </div>
  <a class="carousel-control-prev" href="#indicators" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#indicators" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>

    </div>
  </div>
</div>
                         </div>



</b-card>


<b-card>

  





  <div id="app">
    <div @click="generatePDF()" class="np-btn">Generate PDF</div>
    <b-spinner variant="primary" label="Loading..." v-show="loadingSpinner">{{ loadingPercent }}</b-spinner>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="nightprogrammerpdf"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      :pdf-margin="10"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @progress="onProgress($event)"
      @hasGenerated="hasGenerated()"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div style="margin: 12px 12px">

        
          <img src="https://picsum.photos/500/300" />
          <div>
            <p>
              <strong
                ><a href="http://nightprogrammer.com/" target="_blank"
                  >Nightprogrammer.com</a
                ></strong
              >: Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus
              posuere, tellus lobortis posuere tempor, elit sem varius libero, ac
              vulputate ante orci vel odio. Nam sit amet tortor malesuada tellus
              rutrum varius vel a mauris. Integer volutpat neque mauris, vel imperdiet
              mi aliquet ac. Proin sed iaculis ipsum. Vivamus tincidunt egestas
              sapien, vitae faucibus velit ultricies eget. Donec mattis ante arcu, a
              pretium tortor scelerisque et. Morbi sed dui tempor, consectetur turpis
              sed, tristique arcu.
            </p>
            <p>
              Quisque nec ante faucibus, lobortis neque eget, placerat massa. Mauris
              tincidunt ante faucibus dui semper eleifend. Morbi sit amet velit lacus.
              Maecenas suscipit pulvinar lacus, ac feugiat erat venenatis porta. Donec
              at turpis ultrices, vehicula justo eu, laoreet magna. Ut consequat
              eleifend posuere. Quisque nec ante faucibus, lobortis neque eget,
              placerat massa. Mauris tincidunt ante faucibus dui semper eleifend.
              Morbi sit amet velit lacus. Maecenas suscipit pulvinar lacus, ac feugiat
              erat venenatis porta. Donec at turpis ultrices, vehicula justo eu,
              laoreet magna.
            </p>
          </div>
        </div>
      </section>
    </vue-html2pdf>
    <div>
      <ContentToPrint />
    </div>
  </div>



  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <date-picker v-model="date" :config="options" ></date-picker>
      </div>
    </div>
  </div>

  <div>
    {{ date }}
  </div>

  <div>
    <b-button variant="primary" class="active mt-3" @click="getCookie()">Cookie</b-button>

    <b-button variant="primary" class="active mt-3" @click="newCookie()">Novo Cookie</b-button>

    <b-button variant="primary" class="active mt-3" @click="resetCookie()">Reset Cookie</b-button>

    <p>
      {{  cookeData  }}

      <hr>

      {{  menuData  }}

      <hr>

      {{ testData  }}
    </p>
  </div>
  
</b-card>

<iframe src="http://portalbmwagulhasnegras.com.br" width="100%"></iframe>

</section>

<!-- Modal gallery -->
</template>


<script>

// Import required dependencies 
import 'bootstrap/dist/css/bootstrap.css';

  
  // Import this component
  import datePicker from 'vue-bootstrap-datetimepicker';
  
  // Import date picker css
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

  // PDF
  import VueHtml2pdf from "vue-html2pdf";
//import ContentToPrint from '/reports/TecnovalegasVazamento.vue';

export default {
  name: 'test',
  components: {
    datePicker,
    VueHtml2pdf
  },
  data () {
    return {
      fields: [
        { key: 'produto', label: 'Produto' },
        { key: 'quantidade', label: 'Quantidade' },
        { key: 'valorUnitario', label: 'Valor Unitário' },
        { key: 'valorTotal', label: 'Valor Total' }
      ],
      items: [
        { produto: 'Produto 1', quantidade: 0, valorUnitario: 0, valorTotal: 0 },
        { produto: 'Produto 2', quantidade: 0, valorUnitario: 0, valorTotal: 0 },
        // Adicione mais produtos conforme necessário
      ],
      loadingSpinner: false,
      loadingPercent: 0,
      cookeData: "",
      menuData: "",
      testData: "",
      date: new Date(),
      options: {
        format: 'DD/MM/YYYY HH:mm:ss',
        useCurrent: false,
      }       
    }
  },
  methods: {
    newCookie() {
      console.log("Criado cookie")
      this.$cookies.set("smg_new","oa","3600")
    },

    resetCookie() {
      console.log("resetado cookie")
      this.$cookies.set("smg_new","","-1")
    },

    getCookie() {
      console.log("Recuperando Cookie")

     this.cookeData = this.$cookies.get("smg_user")

      this.menuData = this.$cookies.get("smg_menu")

      this.testData = this.$cookies.get("smg_new")
    },

    onProgress(event) {
      console.log(`Processed: ${event} / 100`);
      this.loadingPercent = event
      this.loadingSpinner = true

    },
    hasGenerated() {
      alert("PDF generated successfully!");
      this.loadingSpinner = false;
    },
    generatePDF() {
      this.$refs.html2Pdf.generatePdf();
    },
    updateTotal(index) {
      const item = this.items[index];
      item.valorTotal = item.quantidade * item.valorUnitario;
    }
  }
}
</script>

<style scoped>

.close {
  font-size: 1.5rem;
}

.col-12 img {
  opacity: 0.7;
  cursor: pointer;
  margin: 2rem;
  width: 100%;
}

.col-12 img:hover {
  opacity: 1;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>